module.exports = __webpack_public_path__ + "static/media/schwangerschaft-mobile.da5ee3c5.jpg";